import { RowsPerPageOption } from '../types';

export const getRowsPerPageOptions = (
  options = [25, 50, 100, 250, 500, 1000],
): RowsPerPageOption[] =>
  options.map((limit) => ({ key: limit.toString(), value: limit }));
